module.exports = __webpack_public_path__ + "assets/img/20_51_big.06e2b4f2.jpg";